import { restClient } from '@/Core'

import { toUploadSession } from '../Helpers/diskResponse'

import type { DiskUploadSession } from '../Contracts/DiskUpload'

/** Стан сесії: отримані й відсутні номери шматків — `GET /services/disk/uploads/{uuid}`. */
export const GetDiskUploadTask = async (uuid: string): Promise<DiskUploadSession> => {
    const response = (await restClient.get(
        `/services/disk/uploads/${encodeURIComponent(uuid)}`,
        {},
        { forceRefresh: true }
    )) as unknown

    return toUploadSession(response)
}
